import React from 'react';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { Order } from '@interfaces/models/myOrder';
import { Product } from '@interfaces/models/orderSaleProduct';
import { TimelineConfirmDeliveryAction } from '@interfaces/models/timeline';
import { useTranslation } from 'next-i18next';
import ConfirmDeliveryCommon from './confirm-delivery-common';

const ConfirmDeliveryView: React.FC<{
  closePopin: () => void;
  product: Product;
  order: Order | null;
  confirmDeliveryDetails: TimelineConfirmDeliveryAction;
}> = ({ closePopin, confirmDeliveryDetails, product, order }) => {
  const { t } = useTranslation('orders-sales');
  const { deliveryType } = confirmDeliveryDetails;
  const { sendAnalyticEvent } = useAnalyticEvents('orders_sales_timeline');
  const analyticData = { label: 'buyer', product_id: product.productId };
  const isHomeDelivery = deliveryType === 'home';

  const handleCancel = () => {
    if (isHomeDelivery) {
      sendAnalyticEvent('timeline_home_delivery_popin_cancel', analyticData);
    } else {
      sendAnalyticEvent('timeline_pickup_popin_cancel', analyticData);
    }
  };

  const handleConfirm = () => {
    if (isHomeDelivery) {
      sendAnalyticEvent('timeline_home_delivery_popin_confirm', analyticData);
    } else {
      sendAnalyticEvent('timeline_pickup_popin_confirm', analyticData);
    }
  };

  const title = isHomeDelivery
    ? t('MY_ACCOUNT.ORDERS_SALES.POPUP.HOME_DELIVERY.TITLE')
    : t('MY_ACCOUNT.ORDERS_SALES.POPUP.CONFIRM_DELIVERY.TITLE');

  const body = isHomeDelivery
    ? t('MY_ACCOUNT.ORDERS_SALES.POPUP.HOME_DELIVERY.BODY')
    : t('MY_ACCOUNT.ORDERS_SALES.POPUP.CONFIRM_DELIVERY.BODY');

  return (
    <ConfirmDeliveryCommon
      closePopin={closePopin}
      confirmDeliveryDetails={confirmDeliveryDetails}
      product={product}
      order={order}
      title={title}
      body={body}
      cancelButtonText={t('MY_ACCOUNT.ORDERS_SALES.CANCEL')}
      confirmButtonText={t('MY_ACCOUNT.ORDERS_SALES.CONFIRM')}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  );
};

export default ConfirmDeliveryView;
